<ng-container *ngFor="let agent of agents; let i = index">
    <portfolio-agent-info class="pal-item" [agent]="agent" [showCompany]="showCompany"></portfolio-agent-info>
    <mat-divider *ngIf="i !== agents.length - 1" class="pal-divider"></mat-divider>
</ng-container>
